export enum ApplicationBundleStatus {
  SENT = 'Sent',
  IN_PROGRESS = 'In Progress',
  SUBMITTED = 'Submitted',
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
}
